import React from "react";
import CardWithHeader from "../../../../common/components/card/card-with-header";
import Button from "../../../../common/components/button";
import {fieldsToHtml} from "../../../../common/util/util-fields";
import {VEHICLE_TYPES, isOdometerVisible} from "./dot-inspection-config";

const IDENTIFICATION_FIELD_NAMES = [
    'ReportNumber', 'InspectionDate', 'CarrierID', 'Company', 'USDOTNumber', 'UnitNumber',
    'VIN', 'LicensePlate', 'Make', 'Year', 'Odometer', 'InspectionAgency'
];

export default function DotInspectionHeaderSection({fields, vehicleType, onVehicleTypeChange, onFieldsChange, selects, translate, afterTitle}) {
    // Only one of CarrierID (repair shop) / Carrier (own company) exists in fields
    const fieldsForDisplay = IDENTIFICATION_FIELD_NAMES.filter((name) => !!fields[name]).map((name) => {
        const field = fields[name];

        if (name === 'Odometer' && !isOdometerVisible(vehicleType)) {
            return Object.assign({}, field, {metadata: Object.assign({}, field.metadata, {hideDialog: true})});
        }

        return field;
    });

    const fieldsHtml = fieldsToHtml(fieldsForDisplay, translate, onFieldsChange, selects);

    return (
        <CardWithHeader title={translate('card_header.dot_inspection_identification')} afterTitle={afterTitle}>
            <div>
                <span className="block text-sm font-semibold text-tm-gray-700 mb-1">
                    {translate('field.dot_vehicle_type')}
                </span>

                <div className="flex flex-wrap gap-2">
                    {VEHICLE_TYPES.map((vt) => (
                        <Button
                            key={vt.value}
                            appearance={vehicleType === vt.value ? 'primary' : undefined}
                            onClick={() => onVehicleTypeChange(vt.value)}
                        >
                            {translate(vt.labelKey)}
                        </Button>
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-6 gap-4">
                {fieldsHtml}
            </div>
        </CardWithHeader>
    );
}
